<ng-template #lookupAndPeopleContainer>
  <edx-action-bar #actionbar [menuID]="actionId" [target]="this"></edx-action-bar>
  <div class="listcontainer" id="edx_admin_list_container" tabindex="0" (keydown)="onKeyDown($event)">
    <edx-list-table #lookupTable [parent]="this" [desc]="lookupDesc" [lookupForm]="lookupForm"
      [lookupKey]="lookupKey" [formType]="lookupFormType" [leadingColums]="lookupLeadingColums"
    [inlineActionMenuId]="6" [inlineActionTarget]="this"></edx-list-table>
  </div>
</ng-template>

@if (ui<2 && !!tabId) {
  <div class="window-modal-admin window-modal" [ngClass]="{web:ui===0, desktop:ui===1}"
    (keyup.enter)="rightHdrBtnClick($event)" (keyup.escape)="cancelHdrBtnClick()">
    @if (ui<2) {
      <edx-window-modal-header [title]="getName()" [desc]="desc"
        [rightBtn]="tabId!=='LOOKUPS' && tabId!=='PEOPLE'?labels['saveStr']:None" [showCancel]="tabId!=='LOOKUPS' && tabId!=='PEOPLE'" [areHeaderButtonsDisabled]="areHeaderButtonsDisabled()" (rightHdrBtnClick)="rightHdrBtnClick()"
      (cancelHdrBtnClick)="cancelHdrBtnClick()" [libraries]="librarySelectItems" (libraryChangeEvent)="libraryChangeEvent($event)"></edx-window-modal-header>
    }
    @if (!showSpinner&&ui<2) {
      <div class="tabcontainer">
        <edx-tab-selector #tabSelector [receiver]="this" [tabdefs]="tabList" [disable]="showSave"></edx-tab-selector>
      </div>
      <div class="contentpanel admincontainer">
        <div class="adminlistcontainer">
          @if (canShowLeftPane(tabId)) {
            <div class="left">
              @if (!showFilter) {
                <div>
                  <ng-container *ngTemplateOutlet="searchBoxSection"></ng-container>
                </div>
              }
              @if (!showFilter && tabId !== PEOPLE) {
                <edx-filelist-sidebar [receiver]="this" [list]="leftNavList"
                  [selectIndex]="leftNavSelectedIndex" [desc]="desc" [disabled]="showSave"
                [tabIndex]="0"></edx-filelist-sidebar>
              }
              <edx-filter-sidebar [target]="this"></edx-filter-sidebar>
            </div>
          }
          @if (contentLoaded) {
            <div class="right" [ngClass]="{'child-tab-container': canShowChildTabs(tabId)}">
              @switch (tabId) {
                @case ('LOOKUPS') {
                  <ng-container *ngTemplateOutlet="lookupAndPeopleContainer"></ng-container>
                }
                @case ('PEOPLE') {
                  <ng-container *ngTemplateOutlet="lookupAndPeopleContainer"></ng-container>
                }
                @default {
                  @if (canShowChildTabs(tabId)) {
                    <div class="tabcontainer">
                      <edx-tab-selector #tabSelector [receiver]="this" [tabdefs]="childTabList" [disable]="showSave"></edx-tab-selector>
                    </div>
                  }
                  <div class="settingwrapper" [ngClass]="{leftPadding: tabId==='GROUPS'}">
                    @if (tabId!=='GROUPS' && tabId !== 'SYSTEM_PARAMS') {
                      <div class="headerwrapper" >
                        <div class="settingdiv" [ngClass]="{general:tabId==='GENERAL',footer:tabId==='FOOTER'}">
                          @for (column of contentColumns; track column) {
                            <div class="settingcolumn checkboxlabel" [ngClass]="{general:tabId==='GENERAL',footer:tabId==='FOOTER'}">
                              <span>{{column}}</span>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <edx-form-wrapper #formWrapper [kind]="contentFormKind" [desc]="desc" [formData]="formData"
                    (okEnabled)="okEnabled($event)" (formDataChanged)="updateFormData($event)"></edx-form-wrapper>
                  </div>
                }
              }
            </div>
          }
          @if (tabId === 'GROUPS' && !contentLoaded) {
            <div class="no-items-msg">
              <span>{{labels['noItemsMsg']}}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (showSpinner) {
      <edx-spinner></edx-spinner>
    }
  </div>
}
<ng-template #searchBoxSection>
  <div class="searchBoxSection" [ngClass]="{disabled:showSave}">
    @if (showSearchBar()) {
      <div class="search-bar" >
        <input #searchGroup [placeholder]="labels['searchByGroup']" class="search-text" [ngClass]="{group: tabId === 'GROUPS'}" (keyup)="clearSearchWhenEmpty($event)" (keyup.enter)="searchClicked($event)" [(ngModel)]="searchValue" type="text" id="search" name="search" [disabled]="showSave"/>
        @if (searchValue) {
          <div role="button" id="edx_search_group_clr_btn" [title]="labels['clear']" tabindex="0" class="icon clear" [ngClass]="{'has-add-menu':canCreateNewGroup()}" (keyup.enter)="searchClicked($event,true)" (keyup.space)="searchClicked($event,true)" (click)="searchClicked($event,true)"></div>
        }
        <div role="button" id="edx_search_group_btn" tabindex="0" [title]="labels['refineSearch']" class="icon search" [ngClass]="{disableHover:showSave,'has-add-menu':canCreateNewGroup()}" (keyup.space)="searchClicked($event)" (keyup.enter)="searchClicked($event)" (click)="searchClicked($event)"></div>
        @if (canCreateNewGroup()) {
          <div [ngClass]="{disabled: showSave}" role="button" [tabindex]="showSave? -1 : 0" [title]="labels['createGroup']" id="edx_admin_group_add_btn" class="icon add" (click)="doCommand('group_create')" (keyup.space)="doCommand('group_create')"  (keyup.enter)="createGroup($event)"></div>
        }
      </div>
    }
    @if (showInfoMessage && tabId !== 'LOOKUPS' && tabId !== 'SYSTEM_PARAMS') {
      <div role="status" class="info-message" tabindex="0" title="{{infoMessage}}" [attr.aria-label]="infoMessage" >{{infoMessage}}</div>
    }
    @if (isFiltering) {
      <edx-spinner [mini]="true"></edx-spinner>
    }
  </div>
</ng-template>